import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

export const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1563166423-482a8c14b2d6?w=1920&q=80"
          alt="Construction professionnelle"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 via-blue-800/90 to-blue-900/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Votre partenaire en{' '}
            <span className="text-blue-300">second œuvre</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-blue-100 mb-8 leading-relaxed">
            RCCB vous accompagne dans tous vos projets de peinture, plâtrerie, plomberie, sols, carrelage et travaux de bricolage avec expertise et professionnalisme.
          </p>

          {/* Key Points */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10">
            <div className="flex items-center space-x-3">
              <CheckCircle2 className="text-blue-300 flex-shrink-0" size={24} />
              <span className="text-white text-lg">Entreprise certifiée</span>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle2 className="text-blue-300 flex-shrink-0" size={24} />
              <span className="text-white text-lg">Devis gratuit sous 48h</span>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle2 className="text-blue-300 flex-shrink-0" size={24} />
              <span className="text-white text-lg">Garantie décennale</span>
            </div>
            <div className="flex items-center space-x-3">
              <CheckCircle2 className="text-blue-300 flex-shrink-0" size={24} />
              <span className="text-white text-lg">Intervention rapide</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={scrollToContact}
              className="bg-white text-blue-900 hover:bg-blue-50 px-8 py-6 text-lg font-semibold rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
            >
              Demander un devis gratuit
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Button
              onClick={() => {
                const element = document.getElementById('services');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              variant="outline"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-blue-900 px-8 py-6 text-lg font-semibold rounded-xl transition-all duration-300"
            >
              Découvrir nos services
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
